export interface IExpenseItem {
    id?: number,
    specialItemType?: string,
    quantity: string,
    description: string,
    price?: number,
}

export enum EBilling {
    annual = '12-MONTHS',
    sixMonths = '6-MONTHS',
    sixMonthsPost = '6-MONTHS-POST',
}


export interface IContract {
    id?: number,
    costumer: number,
    serial_number?: number,
    serial_suffix?: number
    start_validity: string,
    end_validity: string,
    date: string,
    billing: EBilling,
    billing_months: string[],
    city: string,
    items: IExpenseItem[],
    deadlines?: string[],
    monitoring_rodent: boolean,
    monitoring_crawling: boolean,
    haccp: boolean,
    monitoring_flying: boolean,
    monitoring_flours_pests: boolean,
}

export function compareContractDate(A: IContract, B: IContract) {
    const dateA: Date = new Date(A.start_validity);
    const dateB: Date = new Date(B.start_validity);
    if (dateA < dateB)
        return -1;
    else if (dateA == dateB)
        return 0;
    else // (dateA > dateB)
        return 1;
}
